/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Table, {Row, Column} from 'components/Table';
import Code from 'components/Code';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    a: "a",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: _jsx(_components.code, {
        children: "ThemeProvider"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["A helper component for theming. Injects the theme into all styled components anywhere\nbeneath it in the component tree, via the context API.\nCheck the section on ", _jsx(_components.a, {
        href: "/docs/advanced#theming",
        children: "Theming"
      }), "."]
    }), "\n", _jsx(Table, {
      head: ['Props', 'Description'],
      children: _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "theme"
          })
        }), _jsx(Column, {
          children: _jsxs(_components.p, {
            children: ["An object that will be injected as ", _jsx(Code, {
              children: "theme"
            }), " into all\ninterpolations in styled components beneath the provider."]
          })
        })]
      })
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// import styled, { ThemeProvider } from 'styled-components'\n\nconst Box = styled.div`\n  color: ${props => props.theme.color};\n`\n\nrender(\n  <ThemeProvider theme={{ color: 'mediumseagreen' }}>\n    <Box>I'm mediumseagreen!</Box>\n  </ThemeProvider>\n)\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
